const PRIORITY_ORDER = ["Emergency", "Urgent", "Critical", "High", "Medium", "Low", "Minimal", "Least"];
const getDataFromDeptResponse = (res, user) => {
  if (!res || !res.dept_status_list || Object.keys(res.dept_status_list).length === 0) {
    return [];
  }
  if (res.dept_status_list) {
    let dept_compliance = [];
    const brandname = user?.org?.brandname;
    let totalRow = {
      department: brandname,
      max_aging: 0,
      avg_aging: 0,
      total: 0,
      complete: 0,
      inprogress: 0,
      pending: 0,
      other: 0,
      highlight: true,
    };
    let departmentMap = {};

    for (const key in res.dept_status_list) {
      let correctedKey = key.replace(/\s/g, "");
      const normalizedKey = (correctedKey || "InfoSec").toLowerCase();
      const deptStatus = res.dept_status_list[key];
      const total = parseInt(deptStatus.total, 10) || 0;
      const max_aging = parseInt(deptStatus.max_aging, 10) || 0;
      const avg_aging = parseInt(deptStatus.avg_aging, 10) || 0;
      const complete = parseInt(deptStatus.Complete, 10) || 0;
      const pending = parseInt(deptStatus.Pending, 10) || 0;
      const inprogress = parseInt(deptStatus.InProgress, 10) || 0;
      const other = total - (complete + inprogress + pending);

      if (departmentMap[normalizedKey]) {
        departmentMap[normalizedKey].max_aging += total;
        departmentMap[normalizedKey].avg_aging += total;
        departmentMap[normalizedKey].total += total;
        departmentMap[normalizedKey].complete += complete;
        departmentMap[normalizedKey].inprogress += inprogress;
        departmentMap[normalizedKey].pending += pending;
        departmentMap[normalizedKey].other += other;
      } else {
        departmentMap[normalizedKey] = {
          department: correctedKey,
          max_aging: max_aging,
          avg_aging: avg_aging,
          total: total,
          complete: complete,
          inprogress: inprogress,
          pending: pending,
          other: other,
        };
      }
    }

    dept_compliance = Object.values(departmentMap);
    totalRow.total = dept_compliance.reduce((sum, department) => sum + department.total, 0);
    totalRow.complete = dept_compliance.reduce((sum, department) => sum + department.complete, 0);
    totalRow.inprogress = dept_compliance.reduce((sum, department) => sum + department.inprogress, 0);
    totalRow.pending = dept_compliance.reduce((sum, department) => sum + department.pending, 0);
    totalRow.other = dept_compliance.reduce((sum, department) => sum + department.other, 0);
    const agg = res.aggregated_dept_status_results || {};
    totalRow.max_aging = agg.max_aging ?? "-";
    totalRow.avg_aging = agg.avg_aging ?? "-";
    dept_compliance.sort((a, b) => a.department.toLowerCase().localeCompare(b.department.toLowerCase()));

    dept_compliance.unshift(totalRow);
    dept_compliance = dept_compliance.filter((row) => {
      return Object.entries(row).some(([key, value]) => key !== "department" && value !== 0);
    });
    dept_compliance.forEach((row) => {
      Object.keys(row).forEach((columnKey) => {
        if (row[columnKey] === 0 || row[columnKey] === "0") {
          row[columnKey] = "-";
        }
      });
    });
    dept_compliance.forEach((row) => {
      if (row.max_aging !== "-" && row.max_aging != null) {
        row.max_aging = `${row.max_aging} d`;
      }
      if (row.avg_aging !== "-" && row.avg_aging != null) {
        row.avg_aging = `${row.avg_aging} d`;
      }
    });
    return dept_compliance;
  } else {
    return [];
  }
};
const getDataFromPriorityResponse = (res, user) => {
  if (!res || !res.priority_status_list || Object.keys(res.priority_status_list).length === 0) {
    return [];
  }
  if (res.priority_status_list) {
    const brandname = user?.org?.brandname;
    const aggregated = res.aggregated_priority_stat_results || {};
    let totalRow = {
      priority: brandname,
      Total: 0,
      Complete: 0,
      InProgress: 0,
      Pending: 0,
      Other: 0,
      max_aging: aggregated?.max_aging || 0,
      avg_aging: aggregated?.avg_aging || 0,
      highlight: true,
    };

    const responseData = res.priority_status_list;
    const priorityKeys = ["Emergency", "Critical", "Urgent", "High", "Medium", "Low", "Minimal", "Least"];
    const outputArray = [];

    if ("Default" in responseData) {
      if (!responseData["Medium"]) {
        responseData["Medium"] = {};
      }
      for (let key in responseData["Default"]) {
        if (responseData["Medium"][key] === undefined) {
          responseData["Medium"][key] = 0;
        }
        responseData["Medium"][key] += responseData["Default"][key];
      }
    }

    priorityKeys.forEach((priorityKey) => {
      const rowData = responseData[priorityKey];
      const row = {
        priority: {
          id: priorityKey.toLowerCase(),
          label: priorityKey,
        },
        Total: 0,
        Complete: 0,
        InProgress: 0,
        Pending: 0,
        Other: 0,
        max_aging: 0,
        avg_aging: 0,
      };
      const keyMap = {
        Complete: "Complete",
        InProgress: "InProgress",
        Pending: "Pending",
      };

      if (rowData) {
        for (let status in rowData) {
          const value = rowData[status];
          if (keyMap[status]) {
            row[keyMap[status]] = value;
            row.Total += value;
          } else if (status === "max_aging" || status === "avg_aging") {
            row[status] = value;
          } else if (status !== "total") {
            row.Other += value;
            row.Total += value;
          }
        }

        ["Total", "Complete", "InProgress", "Pending", "Other"].forEach((key) => {
          totalRow[key] += typeof row[key] === "number" ? row[key] : 0;
        });
      }

      outputArray.push(row);
    });
    outputArray.unshift(totalRow);
    const output = outputArray
      .filter((row) => Object.entries(row).some(([key, value]) => key !== "priority" && value !== 0))
      .map((row) => {
        const formatted = { ...row };
        Object.keys(formatted).forEach((key) => {
          if (formatted[key] === 0 || formatted[key] === "0") {
            formatted[key] = "-";
          }
        });
        if (formatted.max_aging !== "-" && formatted.max_aging != null) {
          formatted.max_aging = `${formatted.max_aging} d`;
        }
        if (formatted.avg_aging !== "-" && formatted.avg_aging != null) {
          formatted.avg_aging = `${formatted.avg_aging} d`;
        }
        return formatted;
      });
    return output;
  } else {
    return [];
  }
};

export const getPriorityWiseStatsData = (responseData, user, departments = []) => {
  const tableData = getDataFromPriorityResponse(responseData, user, departments);

  const getName = (v) => (typeof v === "object" && v !== null ? v.label ?? v.id ?? String(v) : String(v));
  const chartDatasets = (() => {
    const brand = user?.org?.brandname;
    const n = (v) => (v === "-" || v == null ? 0 : Number(v));

    const SERIES_ORDER = ["OTHER", "PENDING", "STARTED", "COMPLETE"];
    const FIELD_OF = {
      OTHER: "Other",
      PENDING: "Pending",
      STARTED: "InProgress",
      COMPLETE: "Complete",
    };
    const rows = (tableData || []).filter((r) => r && getName(r.priority) && getName(r.priority) !== brand);

    const byPriority = new Map(rows.map((r) => [getName(r.priority), r]));
    const prioritiesWithData = rows
      .filter((r) => n(r.Other) + n(r.Pending) + n(r.InProgress) + n(r.Complete) > 0)
      .map((r) => getName(r.priority));
    const base = prioritiesWithData.length > 0 ? prioritiesWithData : PRIORITY_ORDER.slice();

    const seen = new Set();
    const axis = [
      ...PRIORITY_ORDER.filter((p) => base.includes(p)),
      ...base.filter((p) => !PRIORITY_ORDER.includes(p)),
    ].filter((p) => (seen.has(p) ? false : (seen.add(p), true)));
    return Object.fromEntries(
      axis.map((name) => {
        const r = byPriority.get(name) || {};
        return [
          name,
          SERIES_ORDER.map((seriesKey) => ({
            key: seriesKey,
            label: seriesKey,
            value: n(r[FIELD_OF[seriesKey]]),
          })),
        ];
      })
    );
  })();
  const donutData = (() => {
    const safeNum = (v) => (v === "-" || v == null ? 0 : Number(v));

    const brandRow = tableData?.[0] ?? null;
    const totalOverall = tableData ? safeNum(brandRow?.Total) : "-";
    const findPriorityRow = (label) =>
      (tableData || []).find((r) =>
        typeof r.priority === "object" ? r.priority.label === label : r.priority === label
      );

    const PRIORITY_META = {
      Emergency: { sortOrder: 8, legendOrder: 1, textColor: "#FFF" },
      Urgent: { sortOrder: 7, legendOrder: 2, textColor: "#FFF" },
      Critical: { sortOrder: 6, legendOrder: 3, textColor: "#FFF" },
      High: { sortOrder: 5, legendOrder: 4, textColor: "#FFF" },
      Medium: { sortOrder: 4, legendOrder: 5 },
      Low: { sortOrder: 3, legendOrder: 6 },
      Minimal: { sortOrder: 2, legendOrder: 7 },
      Least: { sortOrder: 1, legendOrder: 8 },
    };
    const donutDatasets = PRIORITY_ORDER.map((p, i) => ({
      key: p.toUpperCase(),
      value: tableData ? safeNum(findPriorityRow(p)?.Total) : null,
      label: p,
      border: i > 4,
      sortOrder: PRIORITY_META[p].sortOrder ?? i + 1,
      legendOrder: PRIORITY_META[p].legendOrder ?? i + 1,
      textColor: PRIORITY_META[p].textColor ?? "#000",
    }));

    return {
      totalOverall,
      donutDatasets,
    };
  })();
  const columns = [
    {
      typeRepresentation: "TEXT",
      title: "",
      attribute: "priority",
      width: "16%",
    },
    {
      title: "Max Aging",
      attribute: "max_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
      align: "center-right",
    },
    {
      title: "Avg Aging",
      attribute: "avg_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
      align: "center-right",
    },
    {
      typeRepresentation: "TEXT",
      title: "OVERALL",
      id: "Overall",
      attribute: "Total",
      overallFlag: true,
      highlight: { header: true, cell: true },
      align: "center-right",
    },
    {
      typeRepresentation: "TEXT",
      title: "Complete",
      id: "COMPLETE",
      attribute: "Complete",
      align: "center-right",
    },
    {
      typeRepresentation: "TEXT",
      title: "Started",
      id: "STARTED",
      attribute: "InProgress",
      align: "center-right",
    },
    {
      typeRepresentation: "TEXT",
      title: "Pending",
      id: "PENDING",
      attribute: "Pending",
      align: "center-right",
    },
    {
      typeRepresentation: "TEXT",
      title: "Other",
      id: "INVALID",
      attribute: "Other",
      align: "center-right",
    },
  ];

  return {
    tableData: tableData,
    barData: chartDatasets,
    donutData: donutData,
    columns: columns,
  };
};

const getDeptWiseStatsData = (responseData, user, departments = []) => {
  const tableData = getDataFromDeptResponse(responseData, user);

  const chartDatasets = (() => {
    const brand = user?.org?.brandname;
    const n = (x) => (x === "-" || x == null ? 0 : Number(x));

    const SERIES_ORDER = ["OTHER", "PENDING", "STARTED", "COMPLETE"];
    const declaredDepts = (departments || [])
      .map((d) => String(d?.id ?? d?.name ?? d))
      .filter(Boolean)
      .filter((name) => name !== brand);
    const rows = (tableData || []).filter((r) => r && r.department && r.department !== brand);

    const byDept = new Map(rows.map((r) => [r.department, r]));
    const deptsWithData = rows
      .filter((r) => n(r.other) + n(r.pending) + n(r.inprogress) + n(r.complete) > 0)
      .map((r) => r.department);
    const axisDepts = (deptsWithData.length > 0 ? deptsWithData : declaredDepts)
      .slice()
      .sort((a, b) => a.localeCompare(b));

    const FIELD_OF = {
      OTHER: "other",
      PENDING: "pending",
      STARTED: "inprogress",
      COMPLETE: "complete",
    };

    return Object.fromEntries(
      axisDepts.map((name) => {
        const r = byDept.get(name) || {};
        return [
          name,
          SERIES_ORDER.map((s) => ({
            key: s,
            label: s,
            value: n(r[FIELD_OF[s]]),
          })),
        ];
      })
    );
  })();

  const donutData = (() => {
    const brandRow = tableData?.[0] ?? null;
    const safeNum = (v) => (v === "-" || v == null ? 0 : Number(v));

    const totalOverall = tableData ? safeNum(brandRow?.total) : "-";

    const completionPct =
      tableData && safeNum(brandRow?.total) > 0
        ? Math.round((safeNum(brandRow?.complete) * 100) / safeNum(brandRow?.total))
        : 0;
    const rawDonut = tableData
      ? [
          {
            key: "COMPLETE",
            value: safeNum(brandRow?.complete),
            label: "Complete",
            sortOrder: 4,
            legendOrder: 1,
            textColor: "#FFF",
          },
          {
            key: "STARTED",
            value: safeNum(brandRow?.inprogress),
            label: "Started",
            border: "true",
            sortOrder: 3,
            legendOrder: 2,
          },
          {
            key: "PENDING",
            value: safeNum(brandRow?.pending),
            label: "Pending",
            sortOrder: 2,
            legendOrder: 3,
            textColor: "#FFF",
          },
          {
            key: "INVALID",
            value: safeNum(brandRow?.other),
            label: "Other",
            border: "true",
            sortOrder: 1,
            legendOrder: 4,
          },
        ]
      : [
          { key: "COMPLETE", value: null, label: "Complete" },
          { key: "STARTED", value: null, label: "Started" },
          { key: "PENDING", value: null, label: "Pending" },
          { key: "INVALID", value: null, label: "Other" },
        ];
    const EPS = 1e-6;
    const donutDatasetsForChart = rawDonut.map((d) =>
      d.value == null ? d : { ...d, value: d.value === 0 ? EPS : d.value }
    );

    return {
      totalOverall,
      completionPct,
      donutDatasets: donutDatasetsForChart,
    };
  })();

  const columns = [
    {
      typeRepresentation: "TITLE",
      title: "",
      attribute: "department",
      width: "16%",
    },
    {
      title: "Max Aging",
      attribute: "max_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
      align: "center-right",
    },
    {
      title: "Avg Aging",
      attribute: "avg_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
      align: "center-right",
    },
    {
      title: "OVERALL",
      id: "Overall",
      attribute: "total",
      highlight: { header: true, cell: true },
      typeRepresentation: "DOT",
      overallFlag: true,
      align: "center-right",
    },
    {
      title: "Complete",
      id: "COMPLETE",
      attribute: "complete",
      typeRepresentation: "DOT",
      align: "center-right",
    },
    {
      title: "Started",
      id: "Started",
      attribute: "inprogress",
      typeRepresentation: "DOT",
      align: "center-right",
    },
    {
      title: "Pending",
      id: "Pending",
      attribute: "pending",
      headerClassName: "cFE3333",
      typeRepresentation: "DOT",
      align: "center-right",
    },
    {
      title: "Other",
      id: "INVALID",
      attribute: "other",
      typeRepresentation: "DOT",
      align: "center-right",
    },
  ];

  return {
    tableData: tableData,
    barData: chartDatasets,
    donutData: donutData,
    columns: columns,
  };
};
export const parseRemediationStatsData = (responseData, user, departments = []) => {
  const stats = { responseData: responseData };
  stats.department = getDeptWiseStatsData(responseData, user, departments);
  stats.priority = getPriorityWiseStatsData(responseData, user, departments);
  return stats;
};
